import { useState } from 'react'
import { useAllUserList } from '../../assets/api/useAdminApi'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import CustomDivider from '../../shared/utils/CustomDivider'
import { Field, Formik, Form } from 'formik';
import * as yup from "yup";
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField'
import { Button, Grid2 } from '@mui/material'
import UtItem from '../../shared/utils/UtList'
import { useMutation } from '@tanstack/react-query'
import { Grid_Gap, Input_Width } from '../../shared/constants'
import { useToaster } from '../../shared/utils/ToasterProvider'
import { useGetAllNodeZoneList } from '../../assets/nodeApi/getApi/getCommonApi'
import { patchUpdatedZone } from '../../assets/nodeApi/patchApi/patchCommonApi'
import { queryClient } from '../../assets/nodeApi/reactQueryClient';

const AssignZoneToMarketingExecutive = ({ role }) => {
    const [selectedUser, setSelectedUser] = useState({})
    const { data: allUserList, isLoading } = useAllUserList({ role: role })
    const { data: ZoneList, isLoading: isZoneListLoading } = useGetAllNodeZoneList({ user_id: selectedUser?.id })
    const { showToaster } = useToaster();

    const UserOptions = allUserList?.data?.map((item, index) => ({
        label: item?.firstname + " " + item?.lastname,
        value: item?.firstname + " " + item?.lastname,
        id: item?.id,
    })) || []
    const ZoneOptions = ZoneList?.data?.map((item, index) => ({
        label: item?.zone_name,
        value: item?.zone_name,
        id: item?.id,
    })) || []


    const [selectedCoordinator, setSelectedCoordinator] = useState([])
    const handleRemove = (id) => {
        setSelectedCoordinator(prev => prev.filter(apartment => apartment?.id !== id));
    };

    const mutationAssign = useMutation({
        mutationFn: ({ id, formdata }) => patchUpdatedZone(id, formdata),
        onSuccess: () => {
            showToaster('Success', "Zone assigned successfully", 'success')
            queryClient.invalidateQueries({ queryKey: [''] });
            setSelectedCoordinator([])
        },
        onError: () => {
            showToaster("Error Caught While submiting the form", 'Error', 'error');
        },
    });

    const handleAssign = (values, { setSubmitting, resetForm }) => {
        if (selectedCoordinator.length === 0) {
            showToaster('Add Atleast one Coordinator', "Warning", 'warning');
            return;
        }

        const obj = {
            zoneId: selectedCoordinator.map(item => item.id)
        };

        mutationAssign.mutate(
            { id: values?.user_id, formdata: obj },
            {
                onSettled: () => {
                    setSubmitting(false);
                },
                onSuccess: () => {
                    resetForm();
                }
            }
        );
    };

    return (
        <>
            <NormalContainerWithHeader headerText={`Assign Zone to ${role}`}>
                <Formik
                    initialValues={{ user_id: "" }}
                    validationSchema={yup.object().shape({
                        user_id: yup.string().required("User Id is required"),
                    })}
                    onSubmit={handleAssign}
                >
                    {({ resetForm, setFieldValue }) => (
                        <Form>
                            <Grid2 container spacing={Grid_Gap}>
                                <Grid2 children size={12}>
                                    {selectedCoordinator?.map((item, index) => (
                                        <UtItem key={index} text={item?.label} onRemove={() => { handleRemove(item?.id) }} />
                                    ))}
                                </Grid2>
                                <Grid2 children size={Input_Width}>
                                    <Field
                                        name="user_id"
                                        component={IdAutoCompleteField}
                                        options={UserOptions}
                                        label={`Select  ${role}`}
                                        isRequired={true}
                                        isLoading={isLoading}
                                        onValueChange={(val) => {
                                            setSelectedUser(val)
                                        }}

                                    />
                                </Grid2>
                                <Grid2 children size={Input_Width}>
                                    <Field
                                        name="zoneId"
                                        component={IdAutoCompleteField}
                                        options={ZoneOptions}
                                        label="Select Zone "
                                        isRequired={true}
                                        isLoading={isZoneListLoading}
                                        onValueChange={(newValue) => {
                                            setSelectedCoordinator((prev) => {
                                                const exists = prev?.find((item) => item?.id === newValue?.id);
                                                return exists ? prev : [...prev, newValue];
                                            });
                                            setFieldValue("cluster_ids", "")
                                        }}

                                    />
                                </Grid2>

                            </Grid2>
                            <CustomDivider />
                            <Grid2 container spacing={Grid_Gap} sx={{ display: "flex", justifyContent: "end" }}>
                                <Grid2 children size={{ xs: 12, sm: 3 }}>
                                    <Button variant='outlined' fullWidth onClick={() => { resetForm(); setSelectedCoordinator() }}>Cancel</Button>
                                </Grid2>
                                <Grid2 children size={{ xs: 12, sm: 3 }}>
                                    <Button variant='contained' type="submit" fullWidth>Submit</Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </NormalContainerWithHeader>
            <CustomDivider />
        </>
    )
}

export default AssignZoneToMarketingExecutive
